[
    {
        "title": "[en]Home[/en][ja]ホーム[/ja]",
        "link": "/"
    },
    {
        "title": "[en]About \"Dynamic Brain\"[/en][ja]\"Dynamic Brain\"とは[/ja]",
        "link": "/documents/concept.html"
    },
    {
        "title": "[en]Articles[/en][ja]特集記事[/ja]",
        "link": "/mediawiki/"
    },
    {
        "title": "[en]Academic Conferences[/en][ja]学術会議[/ja]",
        "link": "/mediawiki/Academic_conferences"
    },
    {
        "title": "[en]Collaborative Projects[/en][ja]連携プロジェクト[/ja]",
        "link": "/mediawiki/Collaborative_Projects"
    },
    {
        "title": "[en]Collaborative Hackathon[/en][ja]連携ハッカソン[/ja]",
        "link": "/mediawiki/Hackathon_Page"
    },
    {
        "title": "[en]Models[/en][ja]数理モデル[/ja]",
        "link": "/database/search/itemtype/model"
    },
    {
        "title": "[en]How to get \"PhysioDesigner\"[/en][ja]PhysioDesignerダウンロード[/ja]",
        "link": "http://physiodesigner.org/download/"
    },
    {
        "title": "[en]See more...[/en][ja]更に見る...[/ja]",
        "link": "/database"
    }
]
